import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import { impulsePageJsonLd } from '../seo/structuredData';
import impulses from '../content/impulses';
import enInsights from '../i18n/enInsights';
import { useI18n } from '../i18n/I18nContext';
import './Impulse.css';

function formatDate(isoDate) {
  return new Date(isoDate).toLocaleDateString('de-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function renderBodyBlock(block, index) {
  const trimmed = block.trim();
  if (!trimmed) return null;

  if (trimmed.startsWith('### ')) {
    return (
      <h3 key={index} className="michaela-impulse-subheading">
        {trimmed.slice(4)}
      </h3>
    );
  }

  return <p key={index}>{trimmed}</p>;
}

function Impulse() {
  const { lang, copy } = useI18n();
  const posts = lang === 'en' ? enInsights : impulses;

  useEffect(() => {
    const id = window.location.hash.replace('#', '');
    if (!id) return;
    document.getElementById(id)?.scrollIntoView();
  }, []);

  return (
    <div className="michaela-impulse-page">
      <Seo
        page="impulse"
        jsonLd={impulsePageJsonLd(posts, lang)}
      />
      <Header />

      <section className="michaela-impulse-hero">
        <div className="michaela-impulse-hero-content">
          <p className="michaela-impulse-label">{copy.insights.label}</p>
          <h1 className="michaela-impulse-title">{copy.insights.title}</h1>
          <p className="michaela-impulse-intro">
            {copy.insights.intro}
          </p>
        </div>
      </section>

      <section className="michaela-impulse-main">
        <div className="michaela-impulse-container">
          {posts.length === 0 ? (
            <div className="michaela-impulse-empty">
              <p>{copy.insights.empty}</p>
              <Link to={lang === 'en' ? '/en/about' : '/ueber-mich'} className="michaela-impulse-back-link">
                {copy.insights.back}
              </Link>
            </div>
          ) : (
            <div className="michaela-impulse-list">
              {posts.map((item) => (
                <article
                  key={item.id}
                  id={item.slug}
                  className="michaela-impulse-article"
                >
                  {item.kicker && (
                    <p className="michaela-impulse-kicker">{item.kicker}</p>
                  )}
                  <time className="michaela-impulse-date" dateTime={item.date}>
                    {item.dateLabel || formatDate(item.date)}
                  </time>
                  <h2 className="michaela-impulse-article-title mirror-ornament">
                    {item.title}
                  </h2>
                  {item.attribution && (
                    <p className="michaela-impulse-attribution">{item.attribution}</p>
                  )}
                  <div className="michaela-impulse-body">
                    {item.body.split('\n\n').map(renderBodyBlock)}
                  </div>
                  {item.locationLine && (
                    <p className="michaela-impulse-location">{item.locationLine}</p>
                  )}
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer showContactForm={false} />
    </div>
  );
}

export default Impulse;
